import CONSTANS from '@/util/constants'

export default {
  get () {
    return window.axios.get(`${CONSTANS.API_URL}/lineas_produccion`)
  },

  post (params) {
    return window.axios.post(`${CONSTANS.API_URL}/linea_produccion`, params)
  },

  patch (id, params) {
    return window.axios.post(`${CONSTANS.API_URL}/actualizar_lineas_produccion/${id}`, params)
  },

  delete (id) {
    return window.axios.delete(`${CONSTANS.API_URL}/eliminar_lineas_produccion/${id}`)
  },
}
